import {
  Column,
  TableCellRenderer
} from "react-table";
import * as React from "react";

import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";

import { IAPIOrderWithProcessJobError } from "../api/connector.api";
import ErpSyncStatusStyled from "../components/ErpSyncStatus";

export interface ITableColumnParams {
  ActionButton: TableCellRenderer;
}

export const connectorOrderExportIssuesTableColumns = (params: ITableColumnParams): Array<Column<IAPIOrderWithProcessJobError>> => {
  const columns: Array<Column<IAPIOrderWithProcessJobError>> = [
    globalTableColumns.id({ header: "Order ID" }),
    globalTableColumns.id({
      accessor: "processJobId",
      header: "Job ID"
    }),
    globalTableColumns.standardText({
      Header: "Erp status",
      accessor: "erpSyncStatus",
      filterable: false,
      sortable: false,
      Cell: row => {
        return <ErpSyncStatusStyled status={row.value} />;
      }
    }),
    globalTableColumns.date({
      header: "Auto retry",
      accessor: "processJob.autoRetry",
      template: "datetime",
      filterable: false,
      sortable: false
    }),
    globalTableColumns.standardText({
      Header: "Error message",
      accessor: "processJob.statusMessage",
      filterable: false,
      sortable: false,
      width: 300
    }),
    globalTableColumns.date({
      header: "Delivery Date",
      accessor: "orderDeliveryDate",
      ignoreLocal: true,
      filterable: false,
      sortable: false
    }),
    globalTableColumns.actions({
      cell: params.ActionButton,
      width: 200
    })
  ];

  return columns;
};
